
import React from "react";
import { Table } from "@/components/ui/table";
import TableHeader from "./tables/TableHeader";
import StandardTableBody from "./tables/StandardTableBody";
import ChippingTableBody from "./tables/ChippingTableBody";
import { isSpecialPuttsTest, isWedgingTest, isBunkerTest, isChippingTest, getCurrentLevel } from "./scoring/utils";

interface ScoresState {
  [key: string]: (number | null)[];
}

// Define the LevelInfo type to match what's actually being passed
interface LevelInfo {
  level: string;
  // Add any other properties that might be in the LevelInfo object
}

interface ResultsTableProps {
  selectedTest: string | null;
  scores: ScoresState;
  testPoints: string[];
  isChippingTest?: boolean;
  getTestDistances: (testId: string) => Record<string, string>;
  getTableHeadTitle: () => string;
  getFormattedPoint: (point: string) => string;
  getPointTotal: (point: string) => number;
  getGrandTotal: () => number;
  levels?: Record<string, string | LevelInfo>;
}

const ResultsTable: React.FC<ResultsTableProps> = ({
  selectedTest,
  scores,
  testPoints,
  isChippingTest: propIsChippingTest,
  getTestDistances,
  getTableHeadTitle,
  getFormattedPoint,
  getPointTotal,
  getGrandTotal,
  levels = {}
}) => {
  // Determine the current level
  const currentLevel = getCurrentLevel();
  console.log("ResultsTable - Current level:", currentLevel);
  
  // Determine if this is a chipping test if not explicitly set
  const isChippingTestFinal = propIsChippingTest !== undefined 
    ? propIsChippingTest 
    : (selectedTest && isChippingTest(selectedTest)) || false;
    
  console.log("ResultsTable - isChippingTestFinal:", isChippingTestFinal, "selectedTest:", selectedTest);
  
  const isSpecialPutts = isSpecialPuttsTest(selectedTest);
  const isWedging = isWedgingTest(selectedTest);
  const isBunker = isBunkerTest(selectedTest);

  return (
    <div className="overflow-x-auto mt-6">
      <Table>
        <TableHeader 
          isChippingTest={isChippingTestFinal}
          isSpecialPutts={isSpecialPutts}
          getTableHeadTitle={getTableHeadTitle}
          isWedgingTest={isWedging}
        />
        
        {!isChippingTestFinal ? (
          <StandardTableBody 
            testPoints={testPoints}
            scores={scores}
            isSpecialPutts={isSpecialPutts}
            getPointTotal={getPointTotal}
            getGrandTotal={getGrandTotal}
            getTestDistances={getTestDistances}
            selectedTest={selectedTest}
            levels={levels}
            isWedgingTest={isWedging}
            isBunkerTest={isBunker}
          />
        ) : (
          <ChippingTableBody 
            testPoints={testPoints}
            scores={scores}
            getFormattedPoint={getFormattedPoint}
            getPointTotal={getPointTotal}
            getGrandTotal={getGrandTotal}
            getTestDistances={getTestDistances}
            selectedTest={selectedTest}
          />
        )}
      </Table>
    </div>
  );
};

export default ResultsTable;

